var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#509EE3",
  fillRule: "evenodd",
  d: "M12.524 6.216C12.1 4.096 10.234 2.5 8 2.5a4.623 4.623 0 0 0-4.524 3.716A3.703 3.703 0 0 0 0 9.92a3.701 3.701 0 0 0 3.692 3.71h8.616A3.701 3.701 0 0 0 16 9.92a3.703 3.703 0 0 0-3.476-3.704Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudFilled);
export default ForwardRef;